import React from "react";
import Dashboard from "../components/dashboard/Dashboard";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function DashboardPage() {

  return (
    <div>
      <TitleUpdater />
      <Dashboard />
    </div>
  );
}
